// NOTE: See carefully where we are using AuthContext, useAuth and AuthProvider

import React from "react";

// import these "hooks" from react/react-router-dom module in node-modules
import { useContext, useState, useEffect } from "react"

import { useHistory } from "react-router-dom"

import { auth } from "../firebase.js"

// create a new "React Context" which will store all of the user data
const AuthContext = React.createContext()

// Pass AuthContext inside the useContext "react hook". Now, when we call useAuth() from within
// our other files, we'll get access to the AuthContext which will be populated with the user data.
export function useAuth() { return useContext(AuthContext) }

// handle all of the user data inside AuthProvider and use it to wrap "children" components (Chats, Login)
// in App.js
export function AuthProvider({ children }) {
  // loading STATE initialised to true
  const [loading, setLoading] = useState(true);
  // user STATE initialised to null
  const [user, setUser] = useState();
  // call useHistory "hook" from react-router-dom so that we can re-navigate somehwere
  const history = useHistory();

  // userEffect takes two parameters - a callback function and a dependency array.
  // When things mentioned in dependency array change, the userEffect + callback function will be recalled.
  useEffect(() => {
    // whenever the state of the auth changes, call the call-back function. This callback function GIVES
    // us the USER DATA from firebase authentication, which we can use to change the "loading" & "user" STATES.
    auth.onAuthStateChanged((user) => {
      setUser(user);
      setLoading(false);
      // if we have the user, then only navigate to /chats using react-router-dom
      if(user)  history.push('/chats');
    });

  }, [user, history]); // --> bcz we want to call useEffect() whenever we add the user or when we re-navigate

  // whenever working with AuthContext, we need to have one "value" object. In our case, that value
  // will be "user" (i.e user data we get from firebase)
  const value = { user }

  return (
    // AuthContext.Provider is a function which accepts the value. So, we want to show the children components (i.e Chats, Login)
    // if we are NOT loading.
    <AuthContext.Provider value={value}>
      {!loading && children};
    </AuthContext.Provider>
  )
}